import { AodaActions, AodaMutations } from '@/app/features/aoda/aoda.keys';
import { aodaService } from '../aoda/aoda.service';
export const aodaStore = {
  state: {
    aodaForm: {
      firstName: '',
      lastName: ''
    }
  },
  getters: {},
  mutations: {
    [AodaMutations.AodaForm]: (state, payload) => {
      state.aodaForm = payload;
    }
  },
  actions: {
    [AodaActions.SubmitAodaForm]: ({ commit }, payload) => {
      commit(AodaMutations.AodaForm, payload);
      return aodaService.submitAodaForm(payload).then(res => {
        if (res) {
          return res;
        }
      });
    }
  }
};
